import {
  Anchor,
  Content,
  Portal,
  Root,
  Trigger,
} from "@radix-ui/react-popover";
import { ComponentProps, FC } from "react";

import { cn } from "@/lib/utils";

type PopoverProps = ComponentProps<typeof Root>;
type PopoverTriggerProps = ComponentProps<typeof Trigger>;
type PopoverContentProps = ComponentProps<typeof Content>;
type PopoverAnchorProps = ComponentProps<typeof Anchor>;

export const Popover: FC<PopoverProps> = (props) => (
  <Root data-slot="popover" {...props} />
);

export const PopoverTrigger: FC<PopoverTriggerProps> = (props) => (
  <Trigger data-slot="popover-trigger" {...props} />
);

export const PopoverContent: FC<PopoverContentProps> = ({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}) => (
  <Portal>
    <Content
      data-slot="popover-content"
      align={align}
      sideOffset={sideOffset}
      className={cn(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border p-4 shadow-md outline-hidden",
        className,
      )}
      {...props}
    />
  </Portal>
);

export const PopoverAnchor: FC<PopoverAnchorProps> = (props) => (
  <Anchor data-slot="popover-anchor" {...props} />
);
